import { FC, useEffect, useRef, useState } from 'react';
import {
    Menu,
    Dots3Vertical,
    Box,
    Typography,
    Loader,
    Button
} from 'components';
import axios from 'libs/axios';
import { useTranslation } from 'react-i18next';
import { NavItem } from 'components/navigation-drawer/Styled';
import { Container, Title } from 'components/navigation-drawer/NavLink/Styled';

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const login = () => {
    window.location.assign(`${BASE_URL}/api/ui/auth/login`);
};

const logout = () => {
    window.location.assign(`${BASE_URL}/api/ui/auth/logout`);
};

const whoAmI = async () => {
    const response = await axios.get<string>('/api/ui/auth/whoami');

    return response.data;
};

const UserMenu: FC = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [email, setEmail] = useState('');
    const { t } = useTranslation();
    const anchorEl = useRef();

    const getUser = async () => {
        setIsLoading(true);

        const user = await whoAmI();

        setIsLoading(false);

        if (user) {
            setEmail(user);
        }
    };

    useEffect(() => {
        if (isOpen) {
            getUser();
        }
    }, [isOpen]);

    return (
        <>
            <NavItem
                onClick={() => setIsOpen((current) => !current)}
                ref={anchorEl}
                marginTop="auto">
                <Container>
                    <Dots3Vertical />
                    <Title>{t('general.connect')}</Title>
                </Container>
            </NavItem>
            <Menu
                isOpen={isOpen}
                onClose={() => {
                    setIsOpen(false);
                }}
                anchorEl={anchorEl.current}
                anchorOffset={{ x: 50, y: 0 }}>
                <Box
                    p="1.25rem"
                    width="400px"
                    minHeight="150px"
                    display="flex"
                    flexDirection="column"
                    gap="0.5rem">
                    {isLoading && <Loader size="large" />}
                    <Typography
                        variant="h5"
                        weight="bold"
                        color={['grey', 700]}>
                        {t('general.connect_to_timeline')}
                    </Typography>
                    {!isLoading && email && (
                        <>
                            <Typography>
                                {t('general.connected_to_timeline', { email })}
                            </Typography>
                            <Box
                                justifyContent="flex-end"
                                pt="1rem"
                                display="flex">
                                <Button type="contained" onClick={logout}>
                                    {t('general.revoke_access')}
                                </Button>
                            </Box>
                        </>
                    )}
                    {!isLoading && !email && (
                        <>
                            <Typography>
                                {t('general.not_logged_in')}
                            </Typography>
                            <Box
                                justifyContent="flex-end"
                                pt="1rem"
                                display="flex">
                                <Button type="contained" onClick={login}>
                                    {t('general.connect')}
                                </Button>
                            </Box>
                        </>
                    )}
                </Box>
            </Menu>
        </>
    );
};

export default UserMenu;
